var map = {
	"./views/ad": "83d4",
	"./views/ad/": "83d4",
	"./views/ad/index": "83d4",
	"./views/ad/index.vue": "83d4",
	"./views/auth/account": "8aa0",
	"./views/auth/account.vue": "8aa0",
	"./views/auth/role": "62b5",
	"./views/auth/role.vue": "62b5",
	"./views/bookingOrders": "7c68",
	"./views/bookingOrders/": "7c68",
	"./views/bookingOrders/index": "7c68",
	"./views/bookingOrders/index.vue": "7c68",
	"./views/bookingOrders/statistics": "3292",
	"./views/bookingOrders/statistics.vue": "3292",
	"./views/common/regionManager": "c93e",
	"./views/common/regionManager.vue": "c93e",
	"./views/cooperator": "6a56",
	"./views/cooperator/": "6a56",
	"./views/cooperator/index": "6a56",
	"./views/cooperator/index.vue": "6a56",
	"./views/finance": "351c",
	"./views/finance/": "351c",
	"./views/finance/index": "351c",
	"./views/finance/index.vue": "351c",
	"./views/finance/luckydraw": "e379",
	"./views/finance/luckydraw.vue": "e379",
	"./views/finance/orderItem": "1448",
	"./views/finance/orderItem.vue": "1448",
	"./views/finance/recharge": "7dc7",
	"./views/finance/recharge.vue": "7dc7",
	"./views/finance/recharge_old": "910c",
	"./views/finance/recharge_old.vue": "910c",
	"./views/finance/withdrawal": "1b1e",
	"./views/finance/withdrawal.vue": "1b1e",
	"./views/goods": "7732",
	"./views/goods/": "7732",
	"./views/goods/brand": "9796",
	"./views/goods/brand.vue": "9796",
	"./views/goods/category": "a17e",
	"./views/goods/category.vue": "a17e",
	"./views/goods/charact": "df2b",
	"./views/goods/charact.vue": "df2b",
	"./views/goods/components/AddCouponModal": "2571",
	"./views/goods/components/AddCouponModal.vue": "2571",
	"./views/goods/components/AddRankModal": "e696",
	"./views/goods/components/AddRankModal.vue": "e696",
	"./views/goods/components/wangeditor": "3ad6",
	"./views/goods/components/wangeditor.vue": "3ad6",
	"./views/goods/coupon": "aa81",
	"./views/goods/coupon.vue": "aa81",
	"./views/goods/index": "7732",
	"./views/goods/index.vue": "7732",
	"./views/goods/rank": "8cbf",
	"./views/goods/rank.vue": "8cbf",
	"./views/index": "37f9",
	"./views/index/": "37f9",
	"./views/index/components/PanelGroup": "6dbc",
	"./views/index/components/PanelGroup.vue": "6dbc",
	"./views/index/index": "37f9",
	"./views/index/index.vue": "37f9",
	"./views/invoice": "b522",
	"./views/invoice/": "b522",
	"./views/invoice/index": "b522",
	"./views/invoice/index.vue": "b522",
	"./views/login/image/bg.jpg": "ea55",
	"./views/login/login": "dc3f",
	"./views/login/login.vue": "dc3f",
	"./views/manager": "5d3f",
	"./views/manager/": "5d3f",
	"./views/manager/contactLog": "ce8c",
	"./views/manager/contactLog.vue": "ce8c",
	"./views/manager/dailyReport": "b14c",
	"./views/manager/dailyReport.vue": "b14c",
	"./views/manager/fakeData": "d779",
	"./views/manager/fakeData.vue": "d779",
	"./views/manager/feedback": "946f",
	"./views/manager/feedback.vue": "946f",
	"./views/manager/index": "5d3f",
	"./views/manager/index.vue": "5d3f",
	"./views/manager/intendCustomer": "bb9f",
	"./views/manager/intendCustomer.vue": "bb9f",
	"./views/manager/luckydraw": "6d0e",
	"./views/manager/luckydraw.vue": "6d0e",
	"./views/manager/marketData": "9551",
	"./views/manager/marketData.vue": "9551",
	"./views/manager/nongzi": "548d",
	"./views/manager/nongzi.vue": "548d",
	"./views/manager/orderRank": "afb1",
	"./views/manager/orderRank.vue": "afb1",
	"./views/manager/pointsGoods": "821d",
	"./views/manager/pointsGoods.vue": "821d",
	"./views/manager/pointsOrders": "b087",
	"./views/manager/pointsOrders.vue": "b087",
	"./views/manager/questionnaire": "c8baa",
	"./views/manager/questionnaire.vue": "c8baa",
	"./views/manager/service": "6fdd",
	"./views/manager/service.vue": "6fdd",
	"./views/manager/slogan": "2d54",
	"./views/manager/slogan.vue": "2d54",
	"./views/manager/userPost": "235e",
	"./views/manager/userPost.vue": "235e",
	"./views/manager/userPrize": "7f0d",
	"./views/manager/userPrize.vue": "7f0d",
	"./views/manager/userTask": "5b1e",
	"./views/manager/userTask.vue": "5b1e",
	"./views/material/item": "1bdf",
	"./views/material/item.vue": "1bdf",
	"./views/material/list": "d87d",
	"./views/material/list.vue": "d87d",
	"./views/material/tag": "2aac",
	"./views/material/tag.vue": "2aac",
	"./views/merchant/admin_list": "a6c1",
	"./views/merchant/admin_list.vue": "a6c1",
	"./views/merchant/advertising_list": "3a8a",
	"./views/merchant/advertising_list.vue": "3a8a",
	"./views/merchant/merchant_furnish": "7856",
	"./views/merchant/merchant_furnish.vue": "7856",
	"./views/merchant/merchant_setting": "b077",
	"./views/merchant/merchant_setting.vue": "b077",
	"./views/merchant/role_list": "82d2",
	"./views/merchant/role_list.vue": "82d2",
	"./views/notice": "ab43",
	"./views/notice/": "ab43",
	"./views/notice/detail": "e373",
	"./views/notice/detail.vue": "e373",
	"./views/notice/index": "ab43",
	"./views/notice/index.vue": "ab43",
	"./views/operateLog": "01fe",
	"./views/operateLog/": "01fe",
	"./views/operateLog/index": "01fe",
	"./views/operateLog/index.vue": "01fe",
	"./views/orders": "2fbb",
	"./views/orders/": "2fbb",
	"./views/orders/cancel": "5c17",
	"./views/orders/cancel.vue": "5c17",
	"./views/orders/customList": "9e84",
	"./views/orders/customList.vue": "9e84",
	"./views/orders/delivery": "109a",
	"./views/orders/delivery.vue": "109a",
	"./views/orders/detail": "719a",
	"./views/orders/detail.vue": "719a",
	"./views/orders/index": "2fbb",
	"./views/orders/index.vue": "2fbb",
	"./views/orders/specialRecharge": "5730",
	"./views/orders/specialRecharge.vue": "5730",
	"./views/orders/unready": "bab2",
	"./views/orders/unready.vue": "bab2",
	"./views/quality": "4d17",
	"./views/quality/": "4d17",
	"./views/quality/efficiency": "fa8d",
	"./views/quality/efficiency.vue": "fa8d",
	"./views/quality/employees": "37a4",
	"./views/quality/employees.vue": "37a4",
	"./views/quality/goodsIndex": "b3fd",
	"./views/quality/goodsIndex.vue": "b3fd",
	"./views/quality/index": "4d17",
	"./views/quality/index.vue": "4d17",
	"./views/quality/statistics": "bc09",
	"./views/quality/statistics.vue": "bc09",
	"./views/redirect": "ef3c",
	"./views/redirect/": "ef3c",
	"./views/redirect/index": "ef3c",
	"./views/redirect/index.vue": "ef3c",
	"./views/setting/components/update": "5078",
	"./views/setting/components/update.vue": "5078",
	"./views/setting/system": "a902",
	"./views/setting/system.vue": "a902",
	"./views/spec": "7e29",
	"./views/spec/": "7e29",
	"./views/spec/detail": "0373",
	"./views/spec/detail.vue": "0373",
	"./views/spec/index": "7e29",
	"./views/spec/index.vue": "7e29",
	"./views/user": "e382",
	"./views/user/": "e382",
	"./views/user/apply": "4493",
	"./views/user/apply.vue": "4493",
	"./views/user/index": "e382",
	"./views/user/index.vue": "e382",
	"./views/user/travelRegistration": "34dc",
	"./views/user/travelRegistration.vue": "34dc",
	"./views/user/welfarePackage": "d971",
	"./views/user/welfarePackage.vue": "d971",
	"./views/wechat/groups": "ff8a",
	"./views/wechat/groups.vue": "ff8a",
	"./views/wechat/task": "8423",
	"./views/wechat/task.vue": "8423"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8c4";